<template lang="pug">
span
  .md-layout
    .md-layout-item.ml-auto
      md-button.md-warning(
        style='float: right;'
        @click='filterDialog = true')
        v-icon(style='color: black !important; padding-right: 4px;') mdi-filter-variant
        span(style='color: black')
          | {{$t('chatHistory.filter')}}
  .md-layout
    .md-layout-item.md-size-100.mx-auto(style='padding: 0')
      ChatTable(
        ref='chat-table-reference'
        :process-time='processTime')
  GlobalDialog(
    v-model='filterDialog'
    max-width='700px'
    scrollable
    :headerTitle="$t('chatHistory.filter')"
    showMButton
    mButtonTextColor='#FE544F'
    mButtonColor='#FE544F'
    mButtonIsOutlined
    :mButtonTitle="$t('chatHistory.reset')"
    @clickMButton='resetFilter()'
    showRButton
    :rButtonTitle="$t('chatHistory.apply')"
    @clickRButton='saveFilter()')
    template(v-slot:content)
      ChatHistoryFilter(:key='resetKey')
</div>
</template>

<script>
import moment from 'moment'
import ChatTable from '@/components/ChatTable'
import GlobalDialog from '@/components/Reuse/GlobalDialog'
import ChatHistoryFilter from '@/components/Filters/ChatHistoryFilter'
import { mapFields } from 'vuex-map-fields'

export default {
  components: {
    ChatTable,
    GlobalDialog,
    ChatHistoryFilter
  },
  computed: {
    ...mapFields('chatHistoryFilter', ['service_code', 'conversation_id', 'user_name', 'cpf', 'email', 'phone', 'bot', 'operator', 'closedTo', 'intents', 'channelFilter', 'evaluationFilter', 'intentFilter', 'activeFilter'])
  },
  data () {
    return {
      filterDialog: false,
      createButton: require('@/../public/img/plus.png'),
      resetKey: 0,
      // Keep local timezone info instead of UTC (default ISO)
      processTime: moment().format('YYYY-MM-DD[T]HH:mm:ssZ')
    }
  },
  methods: {
    saveFilter () {
      this.filterDialog = false
      this.$refs['chat-table-reference'].changeFilters()
    },
    resetFilter () {
      this.$store.dispatch('chatHistoryFilter/resetFilter')
      this.resetKey++
      this.saveFilter()
    }
  }
}
</script>
